"use strict";

import ngUpload from 'ng-file-upload';

angular.module("contartemx.inicio.poliza.duplicar", [
	"contartemx",
	"ngTable",
	"ui.router",
	"ui.bootstrap",
	"datePicker",
	"tableTools",
	"loader",
	ngUpload
])
.service("polizaService", ["$q", "Upload", "callToWebService", "mostrarNotificacion", function ($q, Upload, callToWebService, mostrarNotificacion) {

    return {

        obtenerPantallaVerPoliza: function (numPoliza) {

            var deferred = $q.defer();

            var reject = function error(data) {
                mostrarNotificacion.error(data.Mensaje);
                deferred.reject(data.Mensaje);
            };

            callToWebService.postCall('ObtenerPantallaVerPoliza', { clavePoliza: numPoliza },
                     function sucess(data) {
                        if (!data.EsError && data.Respuesta) {
                            deferred.resolve(data.Respuesta);
                        }
                        else {
                            reject(data);
                        }
                     },
                     reject
                 );

            return deferred.promise;

        },

        obtenerPantallaNuevaPoliza: function () {

            var deferred = $q.defer();

            var reject = function error(data) {
                mostrarNotificacion.error(data.Mensaje);
                deferred.reject(data.Mensaje);
            };

            callToWebService.postCall('ObtenerPantallaNuevaPoliza', {},
                function sucess(data) {
                    if (!data.EsError && data.Respuesta) {
                        deferred.resolve(data.Respuesta);
                    }
                    else {
                        reject(data);
                    }
                },
                reject
            );
            
            return deferred.promise;

        },
        GuardarArchivoPoliza: function (archivo) {

            var deferred = $q.defer();
            var cookie = document.cookie;

            Upload.upload({
                url: '../../../servicios/PortalServicio.svc/GuardarArchivoPoliza',
                method: 'POST',
                headers: { 'Content-Type': false },
                data: { cookie: cookie },
                file: archivo,
                fileFormDataName: 'archivoPoliza'
            }).then(function (response) {
                if (response.data.EsError) {
                    mostrarNotificacion.error('Error al guardar el archivo');
                    deferred.reject(response.data);
                }
                else {
                    deferred.resolve(response.data.Respuesta);
                }
            }, null, function (evt) {

            });

            return deferred.promise;

        },
        GenerarPoliza: function (poliza) {

            var deferred = $q.defer();

            var reject = function (data) {
                mostrarNotificacion.error(data.Mensaje);
                deferred.reject(data.Mensaje);
            };

            callToWebService.postCall('GenerarPoliza', { poliza: poliza },
                function (data) {
                    if (!data.EsError) {
                        mostrarNotificacion.info(data.Mensaje);
                        deferred.resolve(data.Respuesta);
                    }
                    else {
                        reject(data);
                    }
                }, reject);

            return deferred.promise;
        }
    };

}])
.controller("PolizaDuplicarCtrl", ["$scope", "Upload", "$state", "$stateParams", "$filter", "callToWebService", "fileUploadService", "mostrarNotificacion", "$uibModal", "dateTools", "polizaService", "$q",
function ($scope, $upload, $state, $stateParams, $filter, callToWebService, fileUploadService, mostrarNotificacion, $uibModal, dateTools, polizaService, $q) {
    $scope.poliza = {};
	$scope.cuentaSelected = null;
	$scope.selectedRow = -1;
	$scope.guardarComprobanteRespuesta = null;
	$scope.TotalCargos = 0;
	$scope.TotalAbonos = 0;
	$scope.pAgregadas = [];
	$scope.ErrorArchivo = false;
	$scope.ShowCategories = false;
	$scope.ShowSubCategories = true;
	$scope.CategoryChange = false;
	$scope.defaultOpt = { Numero: 0 };
	if($scope.Movil)
		$scope.fechaFactura = moment().format('YYYY-MM-DD');
	else
		$scope.fechaFactura = moment().format('DD/MM/YY');

	$scope.loading = true;

	$q.all([polizaService.obtenerPantallaNuevaPoliza(), polizaService.obtenerPantallaVerPoliza($stateParams.num_pol)])
    .then(function (Respuesta) {
        // Success
        var RespuestaPantallaNueva = Respuesta[0];
        var RespuestaVerPoliza = Respuesta[1];
  
        $scope.CuentasOriginal = RespuestaPantallaNueva.Cuentas;
        $scope.CuentasMayores = RespuestaPantallaNueva.CuentasMayores;
        $scope.Monedas = RespuestaPantallaNueva.Monedas;
        $scope.Cuentas = $scope.CuentasOriginal;

        for (var i = 0; i < $scope.Monedas.length; i++) {
            if ($scope.Monedas[i].CveMoneda === RespuestaVerPoliza.ClaveMoneda) {
                $scope.monedaSeleccionada = $scope.Monedas[i];
                break;
            }
        }

        $scope.poliza.Referencia = RespuestaVerPoliza.Referencia;
        $scope.pAgregadas = RespuestaVerPoliza.Conceptos;
        $scope.TotalCargos = 0;
        $scope.TotalAbonos = 0;

        $scope.pAgregadas.forEach(function (concepto) {
            if (concepto.EsCargo) {
                $scope.TotalCargos += concepto.Monto;
            } else {
                $scope.TotalAbonos += concepto.Monto;
            }
        });

        $scope.Tamano = $scope.pAgregadas.length;
        $scope.LastIndex = $scope.Tamano - 1;

    }, function () {
        // Error
        $state.transitionTo('inicio.poliza');
    }).finally(function () {
        // Finally
        $scope.loading = false;
    });

	$scope.GetCategories = function () {
	    callToWebService.postCall('GetCategories', {},
			    function sucess(data) {
			        if (!data.EsError) {
			            $scope.Categories = data.Respuesta.TiposDeEgreso[1].Categorias;
			        }
			    },
			    function error(data) {
			        mostrarNotificacion.error(data.Mensaje);
			        $scope.loading = false;
			    }
			);
	};

	$scope.GetCategories();

	$scope.GetSubCategories = function () {
	    for (var x = 0; x < $scope.Categories.length; x++) {
	        if ($scope.Categories[x].Numero == $scope.defaultOpt.Numero) {
	            $scope.cuentaMayorSelect.CuentasMenores = $scope.Categories[x].SubCategorias;
	            $scope.ShowSubCategories = true;
	            $scope.CategoryChange = true;
	            break;
	        }
	    }
	};

	$scope.$watch("cuentaSelected", function () {
	    $scope.cuentaInvalida = typeof ($scope.cuentaSelected) !== 'object';
	    if ($scope.Cuentas) {
	        var matches = $filter('filter')($scope.Cuentas, $scope.cuentaSelected);
	        if (matches.length < 1) {
	            if (!$scope.NoSePuedeCrear)
	                $("#popover--nuevoCliente").removeClass('popover--hidden');
	        }
	        else {
	            $("#popover--nuevoCliente").addClass('popover--hidden');
	        }
	    }
	}, true);

	$scope.$watch("cuentaMayorSelect", function (newValue, oldValue) {
		if(newValue != oldValue)
		{
			$scope.NoSePuedeCrear = false;
			if(newValue != null){
				var objFiltrados = $filter('filter')($scope.CuentasOriginal, { ClaveCuentaMayor : newValue.ClaveCuentaMayor }, true);
				$scope.Cuentas = [];
				$scope.Cuentas = objFiltrados;
			}
			else{
				$scope.Cuentas = $scope.CuentasOriginal;
			}

			if (newValue != null && newValue.ClaveCuentaMayor == 11) {
			    $scope.ShowCategories = true;
			    if (!$scope.CategoryChange) {
			        $scope.ShowSubCategories = false;
			        $scope.defaultOpt = { Numero: 0 };
			    }
			} else {
			    $scope.ShowCategories = false;
			    $scope.ShowSubCategories = true;
			    $scope.CategoryChange = false;
			}
		}
    }, true);

    $scope.$watch("cuentaMenorSelect", function (newValue, oldValue) {
		if(newValue != oldValue)
		{
			$scope.NoSePuedeCrear = false;
			if (newValue != null) {
			    if ($scope.ShowCategories) {
			        $scope.NoSePuedeCrear = newValue.NoSePuedeCrear;
			        var objFiltrados = $filter('filter')($scope.CuentasOriginal, { Numero: $scope.cuentaMenorSelect.Numero }, true);
			        $scope.Cuentas = [];
			        $scope.Cuentas = objFiltrados;
			    } else {
			        $scope.NoSePuedeCrear = newValue.NoSePuedeCrear;
			        var objFiltrados = $filter('filter')($scope.CuentasOriginal, { ClaveCuentaMayor: $scope.cuentaMayorSelect.ClaveCuentaMayor, ClaveTipo: newValue.ClaveTipo }, true);
			        $scope.Cuentas = [];
			        $scope.Cuentas = objFiltrados;
			    }
			}
			else{
				if($scope.cuentaMayorSelect != null){
					var objFiltrados = $filter('filter')($scope.CuentasOriginal, { ClaveCuentaMayor : $scope.cuentaMayorSelect.ClaveCuentaMayor }, true);
					$scope.Cuentas = [];
					$scope.Cuentas = objFiltrados;
				}
				else{
					$scope.Cuentas = $scope.CuentasOriginal;
				}
			}
		}
    }, true);

	$scope.select = function (index) {
		$scope.selectedRow = index;
    };

    $scope.deselect = function () {
		$scope.selectedRow = -1;
    };

    $scope.selectedFiles=[];
	$scope.deleteSelectedFile = function(){
		$scope.selectedFiles=[];
	};

	$scope.onFileSelect = function($files) {
		var selFiles = $files;
        if (angular.isString(selFiles[0].name) && selFiles[0].name.length <= 80){
			$scope.selectedFiles = [];
			$scope.progress = [];
			if ($scope.upload && $scope.upload.length > 0) {
				for (var i = 0; i < $scope.upload.length; i++) {
					if ($scope.upload[i] != null) {
						$scope.upload[i].abort();
					}
				}
			}
			$scope.upload = [];
			$scope.uploadResult = [];
			$scope.selectedFiles = $files;
			$scope.dataUrls = [];
			for ( var i = 0; i < $files.length; i++) {
				var $file = $files[i];
				if (window.FileReader && $file.type.indexOf('image') > -1) {
					var fileReader = new FileReader();
					fileReader.readAsDataURL($files[i]);
					var loadFile = function(fileReader, index) {
						fileReader.onload = function(e) {}
					}(fileReader, i);
				}
				$scope.progress[i] = -1;
				if ($scope.uploadRightAway) {
					$scope.start(i);
				}
			}
		}
		else{
		    mostrarNotificacion.error('El nombre del comprobante debe ser menor de 80 caracteres.');
		}
	};

	$(function(){
		$("#upload_link").on('click', function(e){
			e.preventDefault();
			$("#upload:hidden").trigger('click');
		});
	});

	$scope.SeleccionarMonedaDefault = function(){
		for(var i in $scope.Monedas) {
			if($scope.Monedas[i].CveMoneda == 1) {
				$scope.monedaSeleccionada = $scope.Monedas[i];
				break;
			}
		}
	};

	function validarFecha(){
		var fechaGasto = $('#fecha-input').val();
		if($scope.Movil)
			$scope.dateFormat = dateTools.getTimeForWCF(fechaGasto,'YYYY-MM-DD');
		else
			$scope.dateFormat = dateTools.getTimeForWCF(fechaGasto,'DD/MM/YY');
	}

	$scope.validarCargo = function(){
		if($scope.cuentaCargo != 0 && $scope.cuentaCargo != null){
			$scope.cuentaAbono = 0;
		}
		else{
			$scope.cuentaAbono = null;	
		}
	};

	$scope.calcularTotalCargo = function () {

	    $scope.TotalCargos = 0;
	    $scope.pAgregadas.forEach(function (p) {
	        var monto = parseFloat(p.Cargo) || 0;
	        if (monto > 0) {
	            p.Monto = monto;
	            p.EsCargo = true;
	            $scope.TotalCargos += monto;
	        }
	    });

	};

	$scope.validarAbono = function () {
		if($scope.cuentaAbono != 0 && $scope.cuentaAbono != null){
			$scope.cuentaCargo = 0;
		}
		else{
			$scope.cuentaCargo = null;	
		}
	};

	$scope.calcularTotalAbono = function () {

	    $scope.TotalAbonos = 0;
	    $scope.pAgregadas.forEach(function (p) {
 
        var monto = parseFloat(p.Abono) || 0;
	        if (monto > 0) {
	            p.Monto = monto;
	            p.EsCargo = false;
                $scope.TotalAbonos += monto;
	        }
	    });

	};

	$scope.addPolizas = function(f){
		if(!$scope.cuentaSelected.Etiqueta){
			mostrarNotificacion.error("La cuenta selecciona no existe");
			return;
		}
  
		var name = $scope.cuentaSelected.Etiqueta;
		var cargo = Math.round(f.cuentaCargo.$viewValue * 100) / 100;
		var abono = Math.round(f.cuentaAbono.$viewValue * 100) / 100;

		$scope.pAgregadas.push({
			Nombre: $scope.cuentaSelected.Etiqueta,
			Cargo: cargo,
			Abono: abono,
			Monto: ((cargo != 0) ? cargo : abono),
			EsCargo: ((cargo != 0) ? true : false),
			ClaveTipo: $scope.cuentaSelected.ClaveTipo,
			ClaveCuenta: $scope.cuentaSelected.ClaveCuenta
		});
		$scope.Tamano = $scope.pAgregadas.length;
		$scope.LastIndex = $scope.Tamano - 1;
		$scope.TotalCargos += cargo;
		$scope.TotalAbonos += abono;

		clean();
	};

    $scope.savePolizas = function () {
        
        var guardarArchivo;
        var totalCargos = Math.round($scope.TotalCargos * 100) / 100;
        var totalAbonos = Math.round($scope.TotalAbonos * 100) / 100;

        for(var i = 0; i < $scope.pAgregadas.length; i++) {
            if ($scope.pAgregadas[i].Monto === 0) {
                 return mostrarNotificacion.error('El monto de Cargo/Abono es requerido');
            }
        }
            
        if (totalCargos == totalAbonos) {
			$scope.loading = true;
			validarFecha();

			var objSend = {
			    Conceptos: $scope.pAgregadas,
			    ClaveMoneda: $scope.monedaSeleccionada.CveMoneda,
			    Fecha: $scope.dateFormat,
			    TipoDeCambio: $scope.monedaSeleccionada.Valor,
			    Referencia: $scope.poliza.Referencia,
			    NombreArchivo: $scope.guardarComprobanteRespuesta
			};

			if ($scope.selectedFiles.length > 0) {
			    $scope.progress[0] = 0;
			     guardarArchivo = polizaService.GuardarArchivoPoliza($scope.selectedFiles[0]);
			} else {
			     guardarArchivo = $q.when(null);
            }

            guardarArchivo.then(function (nombreArchivo) {
                // Sucess Archivo
                objSend.NombreArchivo = nombreArchivo;
                return polizaService.GenerarPoliza(objSend)
                    .then(function (respuesta) {
                        // Sucess Generar Poliza
                        $state.transitionTo('inicio.poliza.ver_poliza', { num_pol: respuesta });
                    }, function () {
                        // Error Generar Poliza

                    });
            })
            .finally(function () {
                // Finally
                $scope.loading = false;
            });
			
		}
		else{
			mostrarNotificacion.error('El total de Cargos y Abonos debe ser igual');
		}
	};

	function clean(){
		$scope.cuentaSelected = null;
		$scope.cuentaAbono = null;
		$scope.cuentaCargo = null;
	}

	$scope.removePoliza = function(i){
		if(i == null){
			var selRow = $scope.pAgregadas[$scope.selectedRow];
			if(selRow.EsCargo){
				$scope.TotalCargos -= selRow.Monto;
			}
			else{
				$scope.TotalAbonos -= selRow.Monto;
			}
			$scope.pAgregadas.splice($scope.selectedRow,1);
		}
		else{
			var selRow = $scope.pAgregadas[i];
			if(selRow.EsCargo){
				$scope.TotalCargos -= selRow.Monto;
			}
			else{
				$scope.TotalAbonos -= selRow.Monto;
			}
			$scope.pAgregadas.splice(i,1);
		}

		$scope.Tamano = $scope.pAgregadas.length;
		$scope.LastIndex = $scope.Tamano - 1;
		var theads = document.getElementsByTagName('thead');
        theads[0].style.display = 'table-header-group';
        $(".actionsHeader--clientes").css("display","none");
	};

	$scope.arrowDown = function(i){
		var selRow = $scope.pAgregadas[i];
		$scope.pAgregadas.splice(i,1);
		$scope.pAgregadas.splice((i-1),0,selRow);
	};

	$scope.arrowUp = function(i){
		var selRow = $scope.pAgregadas[i];
		$scope.pAgregadas.splice(i,1);
		$scope.pAgregadas.splice((i+1),0,selRow);
	};

	$scope.displayPopup = function () {
	    var modalInstance = $uibModal.open({
          template: require('../../../../../app/views/Inicio/Poliza/NuevaCuenta_modal.html'),
	        controller: 'NuevaCuentaCtrl',
	        windowClass: 'modal--big',
            controllerAs: "nuevaCuentaModal",
	        resolve: {
	            ctsMayores: function () {
	                return $scope.CuentasMayores;
	            },
	            nombrecuenta: function () {
	                return $("#cuentaCuenta").val();
	            },
	            cuentamayorselect: function () {
	                return $scope.cuentaMayorSelect;
	            },
	            categoriaselect: function(){
	                return $scope.defaultOpt;
	            },
	            cuentamenorselect: function () {
	                return $scope.cuentaMenorSelect;
	            },
	            listCategories: function () {
	                return $scope.Categories;
	            },
	            cuentaOriginal: function () {
	                return $scope.CuentasOriginal;
	            }
	        }
	    });

	    modalInstance.result.then(function (data) {
	        polizaService.obtenerPantallaNuevaPoliza().then(function (respuesta) {
                $scope.CuentasOriginal = respuesta.Cuentas;
                $scope.Cuentas = $scope.CuentasOriginal;
            });
	    });

	};

}]);
